export const namespaced = true;

import { basicPresent, basicFieldPresent } from '@/presenters/fields';

export const state = {
  teachingMaterials: [
    {
      productCode: '30',
      id: '6',
      code: '600',
      name: '遊',
    },
    {
      productCode: '40',
      id: '7',
      code: '700',
      name: '魔法の国語',
    },
    {
      productCode: '10',
      id: '4',
      code: '400',
      name: '図形の極',
    },
    {
      productCode: '10',
      id: '1',
      code: '100',
      name: '中学生の図形の極',
    },
    {
      productCode: '10',
      id: '2',
      code: '200',
      name: '数の極',
    },
    {
      productCode: '10',
      id: '3',
      code: '300',
      name: '中学生の代数の極',
    },
    {
      productCode: '20',
      id: '5',
      code: '500',
      name: '数学の悟',
    },
  ],
};

export const getters = {
  getTeachingMaterialById: (state) => (id) => {
    return state.teachingMaterials.find((item) => item.id == id);
  },
  getTeachingMaterialByCode: (state) => (code) => {
    return state.teachingMaterials.find((item) => item.code == code);
  },
  getTeachingMaterialNamesByCodes: (state, getters) => (codes) => {
    if (codes && codes.length > 0) {
      const materialNames = codes.map((code) => {
        const material = getters.getTeachingMaterialByCode(code);
        return basicFieldPresent(material, 'name');
      });
      return basicPresent(materialNames.join('・'));
    }
    return 'ー';
  },
};
